var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import cs from '../_util/classNames';
import Input from './input';
import Button from '../Button';
import IconSearch from '../../icon/react-icon/IconSearch';
import omit from '../_util/omit';
import { ConfigConsumer } from '../ConfigProvider';
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickSearch = function () {
            var onSearch = _this.props.onSearch;
            onSearch && onSearch(_this.state.value);
        };
        _this.onPressEnter = function () {
            var onSearch = _this.props.onSearch;
            onSearch && onSearch(_this.state.value);
        };
        _this.onChangeValue = function (value) {
            _this.setState({
                value: value,
            });
            _this.props.onChange && _this.props.onChange(value);
        };
        _this.focus = function () {
            _this.input && _this.input.focus();
        };
        _this.blur = function () {
            _this.input && _this.input.blur();
        };
        _this.renderSearch = function (_a) {
            var _b;
            var getPrefixCls = _a.getPrefixCls;
            var _c = _this.props, className = _c.className, style = _c.style, placeholder = _c.placeholder, searchButton = _c.searchButton, defaultValue = _c.defaultValue, rest = __rest(_c, ["className", "style", "placeholder", "searchButton", "defaultValue"]);
            var prefixCls = getPrefixCls('input-search');
            var classNames = cs(prefixCls, className, (_b = {},
                _b[prefixCls + "-button"] = searchButton,
                _b));
            var SearchButtonElement = (React.createElement(Button, { type: "primary", onClick: _this.onClickSearch },
                React.createElement(IconSearch, null)));
            var SearchIconElement = React.createElement(IconSearch, { onClick: _this.onClickSearch });
            return (React.createElement(Input, __assign({}, omit(rest, ['onSearch', 'onClear']), { className: classNames, style: style, ref: function (ref) { return (_this.input = ref); }, placeholder: placeholder, addAfter: searchButton ? SearchButtonElement : null, suffix: !searchButton ? SearchIconElement : null, onChange: _this.onChangeValue, defaultValue: defaultValue, onPressEnter: _this.onPressEnter })));
        };
        _this.state = {
            value: props.value || props.defaultValue,
        };
        return _this;
    }
    Search.getDerivedStateFromProps = function (nextProps) {
        if ('value' in nextProps) {
            // 如果配置了 `maxLength`, 需要对值进行截断
            return {
                value: nextProps.maxLength && nextProps.value
                    ? nextProps.value.slice(0, nextProps.maxLength)
                    : nextProps.value,
            };
        }
        return null;
    };
    Search.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderSearch);
    };
    Search.propTypes = {
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        style: PropTypes.object,
        onSearch: PropTypes.func,
        searchButton: PropTypes.bool,
        defaultValue: PropTypes.string,
    };
    Search.defaultProps = {
        onSearch: function () { },
        searchButton: false,
        defaultValue: '',
    };
    return Search;
}(PureComponent));
export default Search;
